<template>
 
    <div v-if="visible" class="fixed inset-0 z-5000" style="z-index: 5000;">
 

    <!-- Overlay -->
    <div  class="absolute inset-0 "  @click="close" ></div>

    <!-- Contenedor libre -->
    <div   class="absolute w-full p-5"  :style="modalStyle" >
      <div class="bg-white  w-full max-w-[1600px]  shadow-lg border-4 border-gray-400  rounded-3xl    ">
      <!-- Header -->
      <div  class="flex items-center  mb-1 rounded-t-2xl justify-between px-6 py-2 bg-gray-500 text-white "  >
        <h2 class="text-lg font-mono">
          Gastos  ({{ detalles.length }} items)  
          <span class="text-sm">&#60;ModalLibroMayorDetalle&#62;</span>
        </h2>

        <button @click="cerrar" class="hover:opacity-80 transition">✕</button>
      </div>

      <!-- Contenido -->
  
      <div class="flex-1 max-h-[600px]  overflow-y-auto p-4">

        <h1 v-if="detalles.length===0">Sin registros</h1>
        <table  v-else class="w-full   text-gray-700 "  >
          <thead class="sticky top-0 bg-gray-50">
            <tr class="border-b text-gray-600   font-mono  text-xs">
              <th
                class="text-center py-2 px-2 cursor-pointer"
                @click="ordenar('id')"
              >
                id  
                <span v-if="campoOrden === 'id'" class="ml-1 text-sm">
                  {{ ordenAsc ? "▲" : "▼" }}
                </span>
              </th>
   <th
                class="text-center py-2 px-2 cursor-pointer"
                @click="ordenar('presupuesto')"
              >
               ID Presupuesto
                <span v-if="campoOrden === 'presupuesto'" class="ml-1 text-sm">
                  {{ ordenAsc ? "▲" : "▼" }}
                </span>
              </th>
              <th
                class="text-center py-2 px-2 cursor-pointer"
                @click="ordenar('tipocomprobante')"
              >
                 Comprobante
                <span
                  v-if="campoOrden === 'tipocomprobante'"
                  class="ml-1 text-sm"
                >
                  {{ ordenAsc ? "▲" : "▼" }}
                </span>
              </th>
              <th></th>
              <th
                class="text-center py-2 px-2 cursor-pointer"
                @click="ordenar('numero')"
              >
                Número
                <span v-if="campoOrden === 'numero'" class="ml-1 text-sm">
                  {{ ordenAsc ? "▲" : "▼" }}
                </span>
              </th>
              <th
                class="text-center py-2 px-2 cursor-pointer"
                @click="ordenar('fecha')"
              >
                Fecha
                <span v-if="campoOrden === 'fecha'" class="ml-1 text-sm">
                  {{ ordenAsc ? "▲" : "▼" }}
                </span>
              </th>

              <th
                class="text-center py-2 px-2 cursor-pointer"
                @click="ordenar('descripcion')"
              >
                Descripción
                <span v-if="campoOrden === 'descripcion'" class="ml-1 text-sm">
                  {{ ordenAsc ? "▲" : "▼" }}
                </span>
              </th>

              <th
                class="text-center py-2 px-2 cursor-pointer"
                @click="ordenar('nombre_centro')"
              >
                Centro
                <span
                  v-if="campoOrden === 'nombre_centro'"
                  class="ml-1 text-sm"
                >
                  {{ ordenAsc ? "▲" : "▼" }}
                </span>
              </th>

              <th
                class="text-center py-2 px-2 cursor-pointer"
                @click="ordenar('nombre_cuenta')"
              >
                Cuenta
                <span
                  v-if="campoOrden === 'nombre_cuenta'"
                  class="ml-1 text-sm"
                >
                  {{ ordenAsc ? "▲" : "▼" }}
                </span>
              </th>

              
              <th
                class="text-center py-2 px-2 cursor-pointer"
                @click="ordenar('total_gastos')"
              >
                  Gastos
                <span v-if="campoOrden === 'total_gastos'" class="ml-1 text-sm">
                  {{ ordenAsc ? "▲" : "▼" }}
                </span>
              </th>

           
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="item in detalles"
              :key="item.id"
              class="even:bg-gray-200 hover:bg-gray-50 transition text-sm font-mono "
            >
              <td class=" px-4 py-2">
                {{ item.id }}
              </td>
              <td>
                {{ item.presupuesto }}
              </td>
              <td >
                {{ item.tipocomprobante }}
              </td>
              <td> <span >{{ item.numero }}</span></td>
              <td>
                  
               <button v-if="item.tipocomprobante=='Cpra_33FCAE'" @click="buscaFactura(item.numero)" style="cursor:pointer"
               class="  items-center  mb-1 ml-1 mt-1
                      px-2 py-2 
                      bg-indigo-500 hover:bg-indigo-600
                      text-white
                      rounded-lg
                      shadow-sm
                      transition" >
            <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
  <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z"/>
</svg></button> 
              <button v-if="item.tipocomprobante=='HONORARIOS'" @click="buscaHonorario(item.numero, item.fecha )" style="cursor:pointer"
               class="  items-center  mb-1 ml-1 mt-1
                      px-2 py-2  
                        bg-indigo-500 hover:bg-indigo-600
                      text-white
                      rounded-lg
                      shadow-sm
                      transition" >
              <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
  <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z"/>
</svg></button> 

            <button v-if="item.tipocomprobante=='TRASPASO'" @click="buscaTraspaso(item.numero)" style="cursor:pointer"
                          class="  items-center  mb-1 ml-1 mt-1
                                  px-2 py-2  
                                    bg-indigo-500 hover:bg-indigo-600
                                  text-white
                                  rounded-lg
                                  shadow-sm
                                  transition" >
                          <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z"/>
            </svg></button> 
            
              </td>
                <td >
                {{ item.fecha  }}
              </td>
              <td >
                {{ item.descripcion }}
              </td>
              <td>
                {{ item.nombre_centro }}
              </td>
              <td >
                {{ item.nombre_cuenta }}
              </td>
              
              <td>
               $  {{ $formatoMiles(item.total_gastos) }}
              </td>
             
            </tr>
          <tr   >
              <td class="py-1 px-4 py-4 text-sm font-mono">
              
              </td>

              <td class="py-1 px-2 py-4 text-sm font-mono">
               
              </td>
              <td class="py-1 px-2 py-4 text-sm font-mono">
                
              </td>
                <td class="py-1 px-2 py-4 text-sm font-mono">
            
              </td>
         
                <td class="py-1 px-2 py-4 text-sm font-mono">
            
              </td>
              <td class="py-1 px-2 py-4 text-sm font-mono">
            
              </td>
              <td class="py-1 px-2 py-4 text-sm font-mono">
             
              </td>
              <td class="py-1 px-2 py-4 text-sm font-mono">
              
              </td> 
              <td class="py-1 px-2 py-4 text-sm font-mono">
              Total gastos
              </td>
              <td class="py-1 px-2 py-4 text-sm font-mono ">
              $   {{ $formatoMiles( totalGastos) }}
              </td>
             
            </tr>
          </tbody>
        </table>

  <button
  @click="cerrar"
  class="  items-center  mb-4 mt-2
         px-4 py-2
         bg-indigo-500 hover:bg-indigo-600
         text-white
         rounded-lg
         shadow-sm
         transition"
>
  
  Cerrar ventana
</button>
      </div>
    </div>
   </div>
  
  
  </div>
</template>

<script>
export default {
  name: "ModalLibroMayorDetalle",
  props: {
    visible: {
      type: Boolean,
    },
    listDetalle: {
      type: Array,
    },
    totalGastos:{
      type: Number
    }
  },
  computed: {
    mesTexto() {
      const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      return this.mes > 0 ? meses[this.mes - 1] : "";
    },
  },
  watch: {
    listDetalle: async function(value){
     
      this.detalles = value;
    }
  },
  methods: {
    cerrar() {
      this.$emit("update:visible", false);
    },

    ordenar(campo) {
      if (this.campoOrden === campo) {
        this.ordenAsc = !this.ordenAsc;
      } else {
        this.campoOrden = campo;
        this.ordenAsc = true;
      }

      this.detalles.sort((a, b) => {
        let A = a[campo];
        let B = b[campo];

        // numérico
        if (!isNaN(A) && !isNaN(B)) {
          return this.ordenAsc ? A - B : B - A;
        }

        // texto
        return this.ordenAsc
          ? String(A).localeCompare(String(B))
          : String(B).localeCompare(String(A));
      });
    },
    buscaFactura(nombreArchivo){
     const archivo = this.$store.getters["facturasGoogleDrive"](nombreArchivo);
       console.log('google drive',archivo.webViewLink);
        var anchor = document.createElement('a');
        anchor.href="404.html";
       if ( archivo?.webViewLink){
          
            anchor.href = archivo.webViewLink;
          
       }
         anchor.target="_blank";
            anchor.click();
    
    } ,  
   buscaHonorario(nombreArchivo ,fecha){
    
     const archivo = this.$store.getters["honorariosGoogleDrive"](nombreArchivo,fecha);
      
      
      var anchor = document.createElement('a');
        anchor.href="404.html";
       if ( archivo?.webViewLink){
          
            anchor.href = archivo.webViewLink;
          
       }
         anchor.target="_blank";
            anchor.click();
    
    } ,
     buscaTraspaso(nombreArchivo ){
    
     const archivo = this.$store.getters["traspasosGoogleDrive"](nombreArchivo );
       
      var anchor = document.createElement('a');
        anchor.href="404.html";
       if ( archivo?.webViewLink){
          
            anchor.href = archivo.webViewLink;
          
       }
         anchor.target="_blank";
            anchor.click();
    
    } ,
  },
  data() {
    return {
      monto_mensual: 0,
      glosa: "",
      rendicion_id: 0,
      mes: 0,
      ordenAsc: true,
      detalles: [],
      campoOrden:'',
      modalStyle:'',
      archivos:false
    };
  },
  mounted() {
    this.detalles = this.listDetalle;
    
  },
};
</script>

<style scoped></style>
